import * as PIXI from "pixi.js";
import HowToPlayLayer from "../../layers/HowToPlayLayer";
import HTPGrid from "./secondPart/HTPGrid";
import HTPEllipse from "./secondPart/HTPEllipse";
import HTPInfoAboutFirework from "./secondPart/HTPInfoAboutFirework";
import ClickAnyWhereSecond from "./secondPart/ClickAnyWhereSecondPart";
import HTPInfoAboutFireworkAnimation from "../../animations/HTPInfoAboutFireworkAnimation";
import HTPClickAnyAnimation from "../../animations/HTPClickAnyAnimation";
import { HTPEllipseColor } from "../../types/Enum";
import { EventBus, EnumEventBus } from "../../managers/EventBus";


export default class HTPSecondPart extends PIXI.Container {
  static instance: HTPSecondPart;
  private HowToPlayLayer = HowToPlayLayer.getInstance();
  private EventBus = EventBus;
  private HTPGrid: HTPGrid;
  private InfoAboutFw: HTPInfoAboutFirework;
  private ClickAnyWhere: ClickAnyWhereSecond;
  private EllipseArr: HTPEllipse[] = [];
  private isReversed:boolean = false;

  constructor() {
    super();
    if (!HTPSecondPart.instance) {
      HTPSecondPart.instance = this;
    }
    this.addToLayer();

    this.InfoAboutFw = new HTPInfoAboutFirework();
    this.InfoAboutFw.visible = false;
    this.addEllipses();
    this.HTPGrid.visible = false;

    this.EventBus.on(EnumEventBus.setHowToPlayMode, mode=>{
      if(!JSON.parse(mode)){
        this.hideEllipsesAndHTPGrid();
      }
    })
  }
  hideEllipsesAndHTPGrid() {
    this.visible = false;
    this.HTPGrid.visible = false;
  }

  runAnimations() {
    this.isReversed = false;
    this.ClickAnyWhere.visible = false;
    this.InfoAboutFw.visible = false;
    this.ClickAnyWhere.scale.set(this.ClickAnyWhere.startScale);
    this.InfoAboutFw.scale.set(this.InfoAboutFw.startScale);

    this.EventBus.emit(EnumEventBus.setHFType, "3");
    this.HTPGrid.visible = true;
    setTimeout(() => {
      this.InfoAboutFw.visible = true;
      new HTPInfoAboutFireworkAnimation(this.InfoAboutFw, 1, () => {
        if(this.isReversed){
          return
        }
        this.ClickAnyWhere.visible = true;
        new HTPClickAnyAnimation(this.ClickAnyWhere, 1, () => {
        })
      })
    }, 500);
  }
  runReverseAnimations(cb: () => void) {
    this.isReversed = true;
    this.ClickAnyWhere.visible = false;
    this.InfoAboutFw.visible = false;
    cb();
  }
  addEllipses() {
    this.HTPGrid = new HTPGrid();
    const fireworks = this.HTPGrid.winningFireworks;
    for (let index = 0; index < fireworks.length; index++) {
      const wFw = fireworks[index];
      if (wFw.isSameColor) {
        const elp = new HTPEllipse(HTPEllipseColor.sameColor);
        elp.x = wFw.firework.x;
        elp.y = wFw.firework.y;
        this.EllipseArr.push(elp);
      }
      if (wFw.isSameType) {
        const elp = new HTPEllipse(HTPEllipseColor.sameType);
        elp.x = wFw.firework.x;
        elp.y = wFw.firework.y;
        this.EllipseArr.push(elp);
      }
    }

    this.ClickAnyWhere = new ClickAnyWhereSecond();
  }
  addToLayer() {
    this.HowToPlayLayer.addChild(this);
  }
  static getInstance() {
    return HTPSecondPart.instance;
  }
}